import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const cornerstone = defineConnector({
  identifier: "cornerstone",
  name: "Cornerstone",
  tagLine: "Learning and talent management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ portalUrl }) => domainToRegex(portalUrl),
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Cornerstone",
      items: [
        {
          kind: "markdown",
          content: `1. In Cornerstone, go to **Edge › Integrations › API Management**
2. Register a new application
3. Copy the **API key** and **API secret**`,
        },
      ],
    },
    {
      title: "Enter your Cornerstone details",
      items: [
        {
          kind: "baseUrl",
          label: "Portal URL",
          required: true,
          placeholder: "https://acme.csod.com",
          target: { kind: "configuration", field: "portalUrl" },
          helperText:
            "Your Cornerstone portal URL (e.g., “https://acme.csod.com”).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ portalUrl }) => `${portalUrl}/services/api/oauth2/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ portalUrl }) =>
      `${portalUrl}/services/api/x/users/v1/employees?$top=1`,
  },
});
